var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f6f6f6"},attrs:{"id":"app"}},[_c('v-app',{staticStyle:{"background":"#f6f6f6"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }